export default (sitemap: SitemapBuilder) =>
{
    sitemap.find('[[[System]]]', '[[[Ustawienia]]]').before('[[[Bezpieczeństwo]]]', [
        {
            name: '[[[Konta użytkowników]]]',
            route: 'studio-accounts',
            icon: 'far fa-fw fa-users',
            auth: { all: ['AdminPermissions@Accounts'], any: [] }
        }
    ]);

    sitemap.after('[[[System]]]', [
        {
            name: '[[[Design Studio]]] (β)',
            short: '[[[Studio]]]',
            icon: 'fa-light fa-circle-nodes',
            namespace: 'Ideo.Core.Common.Application.Permissions.Studio',
            children: [
                {
                    name: '[[[Formularze]]]',
                    icon: 'far fa-fw fa-table-layout',
                    children: [
                        {
                            name: '[[[Definicje]]]',
                            auth: { all: ['FormsPermissions@Access'], any: [] },
                            route: 'studio-forms',
                            children: [
                                {
                                    name: '[[[Edycja definicji]]]',
                                    route: 'studio-forms-edit',
                                    auth: { all: [], any: ['FormsPermissions@Edit', 'FormsPermissions@EditAll'] },
                                    visible: false
                                }
                            ]
                        },
                        {
                            name: '[[[Kategorie]]]',
                            auth: { all: ['FormsPermissions@Access'], any: [] },
                            route: 'studio-forms-categories'
                        }
                    ]
                },
                {
                    name: '[[[Komponenty]]]',
                    icon: 'far fa-fw fa-grid-round-2-plus',
                    auth: { all: ['ComponentsPermissions@Access'], any: [] },
                    route: 'studio-components',
                    children: [
                        {
                            name: '[[[Dodanie komponentu]]]',
                            route: 'studio-components-add',
                            auth: { all: ['ComponentsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja komponentu]]]',
                            route: 'studio-components-edit',
                            auth: { all: ['ComponentsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Źródła danych]]]',
                    route: 'studio-datasources',
                    icon: 'far fa-fw fa-database',
                    auth: { all: ['DataSourcesPermissions@Access'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie źródła danych]]]',
                            route: 'studio-datasources-add',
                            auth: { all: ['DataSourcesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja źródła danych]]]',
                            route: 'studio-datasources-edit',
                            auth: { all: ['DataSourcesPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Moduły]]]',
                    icon: 'far fa-fw fa-layer-group',
                    auth: { all: ['ModulesPermissions@Access'], any: [] },
                    route: 'studio-modules',
                    children: [
                        {
                            name: '[[[Dodanie modułu]]]',
                            route: 'studio-modules-add',
                            auth: { all: ['ModulesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja modułu]]]',
                            route: 'studio-modules-edit',
                            auth: { all: ['ModulesPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[RESTful API]]]',
                    icon: 'far fa-fw fa-brackets-curly',
                    auth: { all: ['EndpointsPermissions@Access'], any: [] },
                    route: 'studio-endpoints',
                    children: [
                        {
                            name: '[[[Dodanie endpointu]]]',
                            route: 'studio-endpoints-add',
                            auth: { all: ['EndpointsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja endpointu]]]',
                            route: 'studio-endpoints-edit',
                            auth: { all: ['EndpointsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Webhooki]]]',
                    icon: 'far fa-fw fa-webhook',
                    auth: { all: ['WebhooksPermissions@Access'], any: [] },
                    route: 'studio-webhooks',
                    children: [
                        {
                            name: '[[[Dodanie webhooka]]]',
                            route: 'studio-webhooks-add',
                            auth: { all: ['WebhooksPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja webhooka]]]',
                            route: 'studio-webhooks-edit',
                            auth: { all: ['WebhooksPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Logi]]]',
                            route: 'studio-webhooks-logs',
                            auth: { all: ['WebhooksPermissions@Access'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Automatyzacja]]]',
                    icon: 'far fa-fw fa-gears', // fa-braille
                    auth: { all: ['AutomationsPermissions@Access'], any: [] },
                    url: '#',
                    route: 'studio-automations',
                    children: [
                        {
                            name: '[[[Edycja scenariusza]]]',
                            route: 'studio-automations-edit',
                            auth: { all: ['AutomationsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Historia]]]',
                            route: 'studio-automations-processes',
                            auth: { all: ['AutomationsPermissions@Edit'], any: [] },
                            visible: false,
                            children: [
                                {
                                    name: '[[[Proces]]]',
                                    route: 'studio-automations-stages',
                                    auth: { all: ['AutomationsPermissions@Edit'], any: [] },
                                    visible: false
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            name: '[[[Moduły]]]',
            short: '[[[Moduły]]]',
            icon: 'fa-light fa-layer-group',
            route: 'studio-docs',
            auth: { all: [], any: [] },
            preventCloseMenu: true
        }
    ]);
};
